/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Supa24Inputs */

const cs_enum_supa24 = /** @type {(inputs: Enum_Supa24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supa24`)
};

const en_enum_supa24 = /** @type {(inputs: Enum_Supa24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supa24`)
};

/**
* | output |
* | --- |
* | "Supa24" |
*
* @param {Enum_Supa24Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_supa24 = /** @type {((inputs?: Enum_Supa24Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Supa24Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_supa24(inputs)
	return cs_enum_supa24(inputs)
});